export default __webpack_public_path__ + "static/media/Letter Y.a20cb32b.mov";